import React, { Component } from 'react';

import {
	PieChart,
	Pie,
	// Sector,
	Cell,
	Tooltip,
	Legend
} from 'recharts';

import UnauthorizedText from './UnauthorizedText';

import { Accent, Primary, Purple, Green, LightGray } from '../helper/consts';

import '../styles/Dashboard.css';

const colors = [Primary, Accent, Purple, Green, LightGray];

export default class AdminJobSummarySelectionPieChart extends Component {
	render() {
		const { job, selectionStages } = this.props;
		let selections = job.selections || {};
		let formatted = [];
		selectionStages.forEach((stage, i) => {
			let sumState = Object.values(selections).filter(stage => stage === i)
				.length;
			if (!!sumState) {
				formatted.push({
					[`name`]: `${stage}`,
					[`value`]: sumState,
					fill: colors.reverse()[i]
				});
			}
		});
		return formatted.length === 0 ? (
			<div className="noData">
				<UnauthorizedText subText="Not Enough Data" />
			</div>
		) : (
			<PieChart width={300} height={300}>
				<Pie
					data={formatted}
					dataKey="value"
					nameKey="name"
					innerRadius={50}
					outerRadius={80}
					paddingAngle={1}
				>
					{formatted.map((entry, index) => <Cell key={index} />)}
				</Pie>
				<Tooltip />
				<Legend />
			</PieChart>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/AdminJobSummarySelectionPieChart.js